// DS-01 fraction off for codes backed by a shopify-checkout-apps discount
// function. Shopify can't report their value, so this mirrors the function.
export const SHOPIFY_FUNCTION_BOGO_CODES: Record<string, number> = {
  FREEGIFT: 0.25,
  FREEGIFTSMS: 0.3,
};
